import React from 'react';
import './_admissionForms.scss';

const StudentFormSuccess = ({ name, onReset }) => {
  return (
    <div className="form-success-wrapper">
      <div className="form-success-card">
        <div className="success-icon-animate mb-4">
          <i className="fas fa-check-circle text-success" style={{ fontSize: '64px' }} />
        </div>
        <h2 className="mb-2">Registration successful! 🎉</h2>
        {/* <p className="mb-1" style={{ fontSize: '18px', color: '#475569' }}>Check your WhatsApp for a confirmation message.</p>
        <p className="sub-text mb-4" style={{ color: '#64748b' }}>
          A summary of your enquiry has been sent to your registered WhatsApp number.
        </p> */}

        {/* <button 
          className="btn btn-primary px-4 py-2 font-weight-bold" 
          onClick={onReset}
          style={{ borderRadius: '8px', fontSize: '15px' }}
        >
          <i className="fas fa-user-plus mr-2" />
          Register Another Student
        </button> */}
      </div>
    </div>
  );
};

export default StudentFormSuccess;
